import request from "../../utils/request";

export function fetchStatsSensorApi(params) {
  // is_paginated=0 page page_size
  return request({
    url: "/api/company-objects/sensor_data/",
    method: "get",
    params
  });
}

